"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class LawFirm extends base_1.default {
    getUser(lfId) {
        return this.get(`/law-firm/get-account/${lfId}`, {});
    }
    createProfile(data) {
        return this.post('/law-firm/create', data);
    }
    updateAccount(params) {
        return this.post(`/law-firm/update`, params);
    }
    deleteAccount(lfId) {
        return this.delete(`/law-firm/delete/${lfId}`);
    }
    updatePracticeAreas(data) {
        return this.post('/law-firm/add-lf-practice-areas', data);
    }
}
exports.default = new LawFirm();
